// src/lib/briefTaxWork.js
//
// Tax work display metadata shared by every case brief (Snapshot/Calculator and intake):
// FINDING_META labels, the applies-status mapping and the Spain/US split. Moved unchanged
// out of CaseBriefPage.js (ticket 072).

// ── Finding display metadata ───────────────────────────────────────────────────
// line1: short obligation identifier
// line2: concise conclusion (more informative than just "applies")

export const FINDING_META = {
  irpf:               { line1: 'IRPF',                    line2: 'Modelo 100 — worldwide income reporting' },
  modelo_210:         { line1: 'Modelo 210 (IRNR)',       line2: 'Non-resident Spain-source income reporting' },
  modelo_720:         { line1: 'Modelo 720',              line2: 'Foreign asset declaration' },
  patrimonio:         { line1: 'Patrimonio',              line2: 'Modelo 714 — regional wealth tax' },
  itsgf:              { line1: 'ITSGF',                   line2: 'Modelo 718 — solidarity tax on large fortunes' },
  autonomo:           { line1: 'Autónomo / RETA',         line2: 'Self-employment + social security obligations' },
  autonomo_setup:     { line1: 'Autónomo registration',   line2: 'RETA + AEAT — one-time setup before starting work' },
  first_time_filer:   { line1: 'First-time filing setup', line2: 'NIE / AEAT registration' },
  beckham_active:     { line1: 'Beckham Law',             line2: 'Modelo 151 — special expat tax regime' },
  capital_gains:      { line1: 'Capital gains',           line2: 'Spain savings base (ahorro) reporting' },
  equity_compensation:{ line1: 'Equity compensation',    line2: 'RSU / option cross-border apportionment' },
  inheritance:        { line1: 'Inheritance / gift',      line2: 'Impuesto de Sucesiones / foreign reporting' },
  us_1040:            { line1: 'US Form 1040',            line2: 'Federal return — worldwide income' },
  fbar:               { line1: 'FBAR',                    line2: 'FinCEN 114 — foreign account reporting' },
  feie_ftc:           { line1: 'FEIE / FTC',              line2: 'Form 2555 / 1116 — foreign income election' },
  pfic:               { line1: 'PFIC',                    line2: 'Form 8621 — passive foreign investment companies' },
  us_rental:          { line1: 'US rental income',        line2: 'Schedule E — US rental property' },
}

export function getFindingDisplay(f) {
  const meta = FINDING_META[f.id]
  return {
    line1: meta?.line1 || f.obligation,
    line2: meta?.line2 || null,
  }
}

// findings' applies status is deterministic rule-engine output (runRules),
// not an AI judgment call — kept as a plain status label.
export function mapStatus(applies) {
  switch (applies) {
    case 'yes':      return { label: 'Applies',        cls: 'brief-status-applies' }
    case 'no':       return { label: 'Not applicable', cls: 'brief-status-not-applicable' }
    case 'possible': return { label: 'Conditional',    cls: 'brief-status-conditional' }
    case 'unknown':  return { label: 'Needs review',   cls: 'brief-status-needs-review' }
    default:         return { label: 'Needs review',   cls: 'brief-status-needs-review' }
  }
}

// ── Jurisdiction helper ───────────────────────────────────────────────────────

const SPAIN_IDS = new Set(['irpf','modelo_210','modelo_720','patrimonio','itsgf','autonomo','autonomo_setup','first_time_filer','beckham_active','capital_gains','equity_compensation','inheritance'])
const US_IDS    = new Set(['us_1040','fbar','feie_ftc','pfic','us_rental'])

export function getJurisdiction(f) {
  if (f.jurisdiction) return f.jurisdiction
  if (SPAIN_IDS.has(f.id)) return 'spain'
  if (US_IDS.has(f.id))    return 'us'
  return 'both'
}
